import { render, staticRenderFns } from "./PricingConfig.vue?vue&type=template&id=217479ab&"
import script from "./PricingConfig.vue?vue&type=script&lang=js&"
export * from "./PricingConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports